export const labels = '#5b727e';
const roadFill = '#d6d6d6';
const roads = [
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [ {
      color: roadFill,
    } ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [ {
      color: roadFill,
    } ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [ {
      color: roadFill,
    } ],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.fill',
    stylers: [ {
      color: roadFill,
    } ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [ {
      color: roadFill,
    } ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text',
    stylers: [ {
      color: '#979b9b',
    } ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [ {
      lightness: 15,
    } ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [ {
      visibility: 'off',
    } ],
  },
];

const landscape = [
  {
    featureType: 'landscape',
    stylers: [ {
      color: '#f2f3ee',
    } ],
  },
  {
    featureType: 'water',
    stylers: [ {
      color: '#b1bebf',
    } ],
  },
  {
    featureType: 'landscape',
    elementType: 'labels.text.fill',
    stylers: [ {
      color: labels,
    } ],
  },
];

const manmade = [
  {
    featureType: 'administrative.land_parcel',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'labels',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'transit',
    stylers: [ {
      visibility: 'off',
    } ],
  },
];

const GoogleMapBaseStyle = [
  ...roads,
  ...landscape,
  ...manmade,
];

export default GoogleMapBaseStyle;
